import React from 'react';
import './ban.css';
import bann from '../assets/bann.png';
import ban2 from '../assets/ban2.png';
import { Link } from 'react-router-dom';

const BookBanner = () => {
  return (
    <div className="banner-wrapper">
      <div className="banner-card">
     <div className="banner-content">
  <p className="banner-subtitle">Our Story</p>
  <h2 className="banner-title">Decades of Dedication to Indian Classical Music Literature</h2>
  <Link to="/about">
    <button className="shop-btn">ABOUT US</button>
  </Link>
</div>

        <div className="banner-image">
          <img src={bann} alt="Music Book Stack" />
        </div>
      </div>

      <div className="banner-card">
        <div className="banner-content">
          <p className="banner-subtitle">For Every Music Lover</p>
          <h2 className="banner-title">Build Your Collection of Music Theory & Practice Guides</h2>
          
<Link to="/book">
  <button className="shop-btn">BROWSE COLLECTION</button>
</Link>
        </div>
        <div className="banner-image">
          <img src={ban2} alt="Books with Stationery" />
        </div>
      </div>
    </div>
  );
};

export default BookBanner;

